import { getInfo,logout } from '@/api/user'

const state = {
  name: '',
  userName: '',
  avatar: '',
  email: '',
  introduction: '',
  phoneNumber: '',
  roles: [],
  author: false,
  authoraddress: '',
  avatarId: '',
  id: ''
}

const mutations = {
  SET_Id: (state, id) => {
    state.id = id;
  },
  SET_AUTHORADDRESS: (state, address) => {
    state.authoraddress = address
  },
  SET_AUTHOR: (state, author) => {
    state.author = author;
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERNAME: (state, userName) => {
    state.userName = userName
  },
  SET_TEL: (state, phoneNumber) => {
    state.phoneNumber = phoneNumber
  },
  SET_AVATARID: (state, AVATARID) => {
    state.avatarId = AVATARID
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_EMAIL: (state, avatar) => {
    state.email = avatar
  },
  CLEAN: state => {
    state.token = ''
    state.name = ''
    state.userName = ''
    state.avatar = ''
    state.email = ''
    state.introduction = ''
    state.phoneNumber = ''
    state.roles = []
    state.avatarId = ''
    state.id = ''
  },
  CLEAN_AUTHOR: state => {
    state.author = false
  }
}

const actions = {
  setId({ commit }, id) {
    commit('SET_Id', id);
  },
  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(async response => {
          if (!response) {
            reject('Verification failed, please Login again.')
          }
          console.log(response, '4444')
          const { userName, name, phoneNumber, email, extraProperties } = response
          commit('SET_NAME', name)
          commit('SET_USERNAME', userName)
          commit('SET_TEL', phoneNumber)
          commit('SET_EMAIL', email)
          commit('SET_INTRODUCTION', extraProperties.Introduction)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('CLEAN')
          resolve()       
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
